export default "__VITE_ASSET__9oe0PsBo__"